import React from "react"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"

const ProgressBarStyled = styled.div`
  background: ${({ theme }) => theme.color.border.divider};
  height: 4px;
  position: relative;
  font-size: 14px;
  margin-bottom: 8px;
  overflow: hidden;

  ${({ $rounded }) =>
    $rounded &&
    css`
      border-radius: 4px;
    `}

  &::after {
    display: block;
    content: " ";
    position: absolute;
    height: 4px;
    background: ${({ theme }) => theme.color.background.progress};
    top: 0;
    left: 0;
    width: ${({ $size }) => $size}%;
  }
`

const ProgressBar = ({ size = 0, rounded = true }) => {
  return (
    <ProgressBarStyled
      role="progressbar"
      $size={size}
      aria-valuenow={size}
      aria-valuemin="0"
      aria-valuemax="100"
      $rounded={rounded}
    >
      Progress {size}%
    </ProgressBarStyled>
  )
}

ProgressBar.propTypes = {
  size: PropTypes.number,
  rounded: PropTypes.bool,
}

export const MfProgressBar = React.forwardRef((props, ref) => (
  <ProgressBar innerRef={ref} {...props} />
))
MfProgressBar.displayName = "MfProgressBar"
